module.exports = {
    title:'Eagle-edu - Amigos',
    courseColleagues:'Colegas de curso',
    follow:'Seguir',
    unfollow:'Deixar de seguir',
    following:'Seguindo',
    followers:'Seguidores',
    friends:'Amigos'
}